import { SearchResultsGroup } from '@interfaces/search-result.interface';

export const EMPTY_SEARCH_RESULTS: SearchResultsGroup = { news: [], products: [], folders: [] };

export const SEARCH_PLACEHOLDER = 'News, Produkte durchsuchen…';

export const RESULT_GROUPS: readonly {
  key: keyof SearchResultsGroup;
  label: string;
  icon: string;
}[] = [
  { key: 'folders', label: 'Beratungsmappe', icon: 'briefcase.svg' },
  { key: 'products', label: 'Produkte', icon: 'category.svg' },
  { key: 'news', label: 'News', icon: 'news-black.svg' }
];
